module.exports = __webpack_public_path__ + "static/cta-banner-background-eee65123360895cca97ee28def663abd.png";